module.exports = __webpack_public_path__ + "static/media/15UN-Habitat9.e27a6b99.jpg";